import React, { useContext as useContextCore, useMemo } from 'react'
import type { UseListResult, UseListWithSelection } from '@ztechapps/common.hook'
import { useListWithSelection } from '@ztechapps/common.hook'
import type { Adjustment } from '@ztechapps/common.contract'
import { useAdjustmentList } from '@ztechapps/adjustment.common'

export type AdjustmentListContextProps = {
  filterCategory?: string
  children: React.ReactNode
}
export type AdjustmentListProps = Omit<AdjustmentListContextProps, 'children'>

export type AdjustmentListContextType = {
  filterCategory: string
  selectedAdjustmentIds: string[]
  selectedAdjustments: Adjustment[]
  adjustmentList: UseListResult<Adjustment>
  adjustmentListWithSelection: UseListWithSelection<Adjustment>
} & AdjustmentListProps

const context = React.createContext({} as AdjustmentListContextType)
const CoreProvider = context.Provider
const defaultFilterCategory = 'adjustmentFilterCategory'

export const AdjustmentListProvider = ({ children, filterCategory, ...rest }: AdjustmentListContextProps) => {
  //set the default filterCategory
  filterCategory = filterCategory ?? defaultFilterCategory

  const adjustmentList = useAdjustmentList({
    listActionOptions: { storageKey: filterCategory },
    subscribeToUpdates: true,
  })
  const adjustmentListWithSelection = useListWithSelection(adjustmentList?.list)
  const selectedAdjustmentIds = useMemo(() => {
    return adjustmentListWithSelection.selectedList.map((item) => item._id)
  }, [adjustmentListWithSelection])
  const selectedAdjustments = adjustmentListWithSelection.selectedList

  return (
    <CoreProvider
      value={{
        ...rest,
        adjustmentList,
        adjustmentListWithSelection,
        filterCategory,
        selectedAdjustments,
        selectedAdjustmentIds,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useAdjustmentListContext = () => useContextCore(context)
